module.exports = __webpack_public_path__ + "img/img1.a9473c28.png";